export default "__VITE_ASSET__2f7ac8ec__"